const ACCOUNTTYPE_MAPPING = {
  CONSUMER_CHECKING: 'C',
  CONSUMER_SAVINGS: 'S',
  CORPORATE_CHECKING: 'X',
  CORPORATE_SAVINGS: 'Y',
};

const encrypt = ({
  modulus, exponent, type,
  bankRoutingNumber, accountNumber, accountName, accountType, postalCode, stateProvince,
  bankCountryCode, bicCode, iban,
}) => {
  const { AMS } = window;

  if (!AMS) {
    throw new Error('No AMS object founded!');
  }

  if (type !== 'ECP' && type !== 'EUDD') {
    throw new Error('No encrypt support type!');
  }

  const accountInfo = new AMS.AccountInfo();
  accountInfo.setModulus(modulus);
  accountInfo.setExponent(exponent);

  if (type === 'ECP') {
    if (bankRoutingNumber) {
      accountInfo.setBankID(`${bankRoutingNumber}`);
    }

    if (accountNumber) {
      accountInfo.setAccountNumber(`${accountNumber}`);
    }

    if (stateProvince) {
      accountInfo.setState(`${stateProvince.slice(0, 50)}`);
    }

    accountInfo.setAccountType(ACCOUNTTYPE_MAPPING[accountType]);
  } else {
    if (bankCountryCode) {
      accountInfo.setCustomerBankCountryCode(`${bankCountryCode}`);
    }

    if (bicCode) {
      accountInfo.setCustomerBankSortCode(`${bicCode}`);
    }

    if (iban) {
      accountInfo.setAccountNumber(`${iban}`);
    }

    accountInfo.setAccountType('C');
  }

  if (accountName) {
    accountInfo.setAccountOwner(`${accountName}`);
  }

  if (postalCode) {
    accountInfo.setZip(`${postalCode.slice(0, 10)}`);
  }

  return AMS.getCipher(accountInfo);
};

export default encrypt;
